import axios from "axios";
import { USER_URL, MASTERDATA_URL } from "./endpoints/user";

const jsonHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const defaultUserManagementRequest = {
  pageNumber: 2147483647,
  pageSize: 100,
  search: "",
  coe: "",
  region: "",
};

export async function fetchUserManagement(request = {}) {
  const payload = {
    ...defaultUserManagementRequest,
    ...request,
  };

  return await axios.post(USER_URL.GetUserManagement, payload, {
    headers: jsonHeaders,
  });
}

export async function updateUser(userData) {
  return await axios.post(USER_URL.UpdateUser, userData, {
    headers: jsonHeaders,
  });
}

export async function deleteUser({ userManagementID }) {
  return await axios.post(
    USER_URL.RemoveUser,
    { userManagementID },
    { headers: jsonHeaders },
  );
}

export async function fetchAllRoles() {
  return await axios.post(MASTERDATA_URL.GetAllRoles, null, {
    headers: jsonHeaders,
  });
}

export async function fetchAllSuperRegions() {
  return await axios.post(MASTERDATA_URL.GetAllSuperRegions, null, {
    headers: jsonHeaders,
  });
}

export async function fetchAllRegions({ superRegionIDs }) {
  return await axios.post(
    MASTERDATA_URL.GetAllRegions,
    { superRegionIDs },
    { headers: jsonHeaders },
  );
}

export async function fetchAllCountries({ superRegionIDs, regionIDs }) {
  return await axios.post(
    MASTERDATA_URL.GetAllCountries,
    { superRegionIDs, regionIDs },
    { headers: jsonHeaders },
  );
}
